import { v4 as uuidv4 } from 'uuid';
import {
	createDefaultAudioLibraryItems,
	getAudioLibraryDefaults,
	normalizeAudioLibraryData,
} from './audioLibrary.js';
import {
	getPayMediaUnlockKey,
	isPayMediaUnlocked,
	normalizePayMediaPriceFields,
	PAY_MEDIA_COMPACT_FREE_COUNT,
	PAY_MEDIA_COMPACT_MAX_ITEMS,
	setPayMediaUnlocked,
} from './payMediaCommon.js';

export const PAY_AUDIO_LIBRARY_TYPE = 'pay-audio-library';
const UNLOCK_PREFIX = 'pay-audio-library';

export function getPayAudioLibraryDefaults(extra = {}) {
	return normalizePayAudioLibraryData(getAudioLibraryDefaults(extra));
}

export function normalizePayAudioLibraryData(data = {}) {
	const base = normalizeAudioLibraryData(data);
	const payFields = normalizePayMediaPriceFields(data, {
		defaultButtonText: '解锁全部音频',
		maxPreviewCount: base.items.length,
	});
	return {
		...base,
		...payFields,
		subtitle: data.subtitle || `共 ${base.items.length} 首精选音频`,
	};
}

export function isPayAudioLibraryBlock(type) {
	return type === PAY_AUDIO_LIBRARY_TYPE;
}

export function getPayAudioLibraryUnlockKey(blockId) {
	return getPayMediaUnlockKey(blockId, UNLOCK_PREFIX);
}

export function isPayAudioLibraryUnlocked(blockId) {
	return isPayMediaUnlocked(blockId, UNLOCK_PREFIX);
}

export function setPayAudioLibraryUnlocked(blockId, unlocked = true) {
	setPayMediaUnlocked(blockId, UNLOCK_PREFIX, unlocked);
}

export function getPayAudioLibraryListEntries(data = {}, { unlocked = false, compact = false } = {}) {
	const normalized = normalizePayAudioLibraryData(data);
	const pageCount = normalized.items.length;
	const freeCount = compact
		? Math.min(PAY_MEDIA_COMPACT_FREE_COUNT, normalized.freePreviewCount, pageCount)
		: normalized.freePreviewCount;

	if (unlocked) {
		const items = compact
			? normalized.items.slice(0, PAY_MEDIA_COMPACT_MAX_ITEMS)
			: normalized.items;
		return items.map((item, index) => ({
			key: item.id,
			item,
			index,
			locked: false,
		}));
	}

	const entries = [];
	normalized.items.slice(0, freeCount).forEach((item, index) => {
		entries.push({ key: item.id, item, index, locked: false });
	});

	if (pageCount > freeCount) {
		const lockIndex = freeCount;
		entries.push({
			key: `locked-${normalized.items[lockIndex]?.id || lockIndex}`,
			item: normalized.items[lockIndex] || normalized.items[freeCount - 1] || { id: uuidv4() },
			index: lockIndex,
			locked: true,
		});
	}

	if (compact) {
		return entries.slice(0, PAY_MEDIA_COMPACT_MAX_ITEMS);
	}

	return normalized.items.map((item, index) => ({
		key: item.id,
		item,
		index,
		locked: index >= freeCount,
	}));
}

export function getPayAudioLibraryPreviewDefaults() {
	return normalizePayAudioLibraryData({
		items: createDefaultAudioLibraryItems(6),
		freePreviewCount: 2,
	});
}
